import axios, { AxiosError } from 'axios';
import { QuestionnaireApi, ApplicationApi, AccountApi, Configuration } from './openapi';

declare module 'axios' {
  export interface AxiosRequestConfig {
    requireAuth?: boolean;
  }
}

const instance = axios.create();

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if ('isAxiosError' in error) {
      const axiosError = error as AxiosError;

      if (axiosError.config.requireAuth !== false && axiosError.response?.status === 401) {
        window.location.href = '/logout';
      }
    }

    return Promise.reject(error);
  }
);

instance.defaults.headers['Accept-Language'] = 'is';
instance.defaults.xsrfHeaderName = 'X-CSRFToken';
instance.defaults.xsrfCookieName = 'csrftoken';
instance.defaults.withCredentials = true;

const basePath = '';

export const applicationApi = new ApplicationApi(
  new Configuration({
    basePath,
  }),
  basePath,
  instance
);

export const accountApi = new AccountApi(
  new Configuration({
    basePath,
  }),
  basePath,
  instance
);

export const questionnaireApi = new QuestionnaireApi(
  new Configuration({
    basePath,
  }),
  basePath,
  instance
);

export default instance;
